import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { CollaborationSessions, SessionStatusArrayValues } from '../../helpers/schema';

export const schema = z.object({
  status: z.enum(SessionStatusArrayValues).optional(),
});

export type InputType = z.infer<typeof schema>;

export type SessionParticipant = {
  id: number;
  displayName: string;
  avatarUrl: string | null;
  isOnline: boolean;
};

export type SessionProgressInfo = {
  fileCount: number;
  todoTotal: number;
  todoCompleted: number;
  lastActivityAt: string | null;
  aiStatus: 'idle' | 'coding' | 'queued' | 'error';
  activeTasks: number;
  errorCount: number;
};

export type OutputType = {
  sessions: (Selectable<CollaborationSessions> & {
    ownerDisplayName: string | null;
    ownerAvatarUrl: string | null;
    ownerIsOnline?: boolean;
    participants?: SessionParticipant[];
    progress?: SessionProgressInfo;
  })[];
};

export const getSessionsList = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  // Convert input object to URLSearchParams
  const params = new URLSearchParams();
  if (input.status) {
    params.append('status', input.status);
  }

  const result = await fetch(`/_api/sessions/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
